import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=7a7b28f3&scoped=true&"
import script from "./ReviewResult.vue?vue&type=script&lang=js&"
export * from "./ReviewResult.vue?vue&type=script&lang=js&"
import style0 from "./ReviewResult.vue?vue&type=style&index=0&id=7a7b28f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b28f3",
  null
  
)

component.options.__file = "ReviewResult.vue"
export default component.exports